export default __webpack_public_path__ + "static/telephone-fb244201058d6b0c101cc5f3713855ee.png";